import { Yield } from '../../abacus/interfaces/yield.interface'

export const validityYields: Yield[] = [
  {
    label: 'Name',
    property: 'name'
  },
  {
    label: 'Description',
    property: 'description'
  }
]
